
import { SaleEditCreateCalendarEventState } from "../../utils/sale-edit/sale-edit-create-calendar-event-state";
import { SaleEditState } from "@/utils/sale-edit/sale-edit-state";
import Vue from "vue";
import AppCalendarModal from "@/components/calendar/CalendarModal.vue";
import { ISelectItem } from "winfakt-vue-components";
import { getEnumKeys, getEnumValueFromKey } from "@/utils/enum";
import {CalendarEvent, GetColorMethod} from "@/models/calendar-event";

export default Vue.extend({
	props: {
		state: {
			type: Object as ()=>SaleEditState,
			required: true
		},
	},
	computed: {
		toEditEvent():CalendarEvent | null{
			return this.state.createCalendarEventState.toEditEvent;
		},
		modalState():SaleEditCreateCalendarEventState{
			return this.state.createCalendarEventState;
		},
		confirmDisabled():boolean {
			if (this.modalState.isSaving) {
				return true;
			}
			if (this.modalState.calendarId == 0){
				return true;
			}
			return false;
		},
		getColorMethodItems():ISelectItem<GetColorMethod>[] {
			return getEnumKeys(GetColorMethod).map(k=>{
				return {
					text: this.$ct(`components.calendar.get-color-method.${k}`),
					value: getEnumValueFromKey(GetColorMethod, k)
				} as ISelectItem<GetColorMethod>;
			});
		},
		showColorPicker():boolean {
			return this.modalState.getColorMethod == GetColorMethod.COLOR_FIELD;
		}
	},
	methods: {
		cancel(){
			this.modalState.cancel();
		},
		confirm(){
			this.modalState.save();
		},
		onSuccess(){
			this.modalState.skip();
		}
	},
	components: {
		AppCalendarModal
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
